const homewords ={
    'titulo':{
        'es':'Casos de estudio',
        'en':'Case Studies'},
}

export default homewords;